import { inBrowser } from 'shared/javascripts/util/environment'

export function parsedFrontendConfig(name: string): unknown {
  const value = frontendConfig(name)
  return value === '' ? null : JSON.parse(value)
}

// Under SSR there is no document and so no config: the same as a missing meta tag, which every consumer
// treats as "not configured".
export function frontendConfig(name: string): string {
  if (!inBrowser()) {
    return ''
  }
  const meta = document.head.querySelector(`[name="${name}"]`) as HTMLMetaElement | null
  return meta?.content ?? ''
}
